import 'core-js';
import 'regenerator-runtime/runtime';
import i18next from 'i18next';
import translationCache from './translation-cache.js';
import { getTranslationHostname } from './utils/translationHostname.ts';

console.log('Loading async translator with custom localStorage caching...');

// Language mapping for du -> de
const languageMap = {
  du: 'du', // Keep du as du
  de: 'du', // Map de to du file
};

// Custom backend that checks cache first, then loads via HTTP
const customBackend = {
  type: 'backend',
  init: function () {},
  read: function (language, _namespace, callback) {
    // Check cache first
    const cached = translationCache.get(language);
    if (cached) {
      callback(null, cached);
      return;
    }

    // Load via HTTP if not cached
    const mappedLanguage = languageMap[language] || language;
    const translationHost = getTranslationHostname(window.location.hostname);
    const url = `https://${translationHost}/public/translate/${mappedLanguage}`;

    console.log(`Loading ${language} translations from ${url}`);

    fetch(url, {
      headers: {
        Accept: 'application/json',
      },
    })
      .then(response => {
        console.log(`HTTP response for ${language}: ${response.status}`);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        console.log(
          `Successfully loaded ${language} translations (${Object.keys(data).length} keys)`
        );

        // Cache the loaded translations
        translationCache.set(language, data);

        callback(null, data);
      })
      .catch(error => {
        console.error(`Failed to load translations for ${language}:`, error);
        callback(error, null);
      });
  },
};

// Create async translator instance
const asyncTranslator = i18next.createInstance();

// Initialize with custom backend (cache -> HTTP)
asyncTranslator
  .use(customBackend)
  .init({
    lng: window.APP_LANG || 'nl',
    fallbackLng: 'nl',
    debug: false,
    ns: 'translations',
    defaultNS: 'translations',
    // Preload all supported languages
    preload: ['nl', 'en', 'de', 'du', 'fr'],
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    // Replace the synchronous translator with the full async one
    const previousTranslator = window.translator;
    window.translator = asyncTranslator;
    window.translator.isInitialized = true;

    console.log(
      'Async translator loaded and replaced synchronous translator for language:',
      window.translator.language
    );

    // Emit event to notify components that full translations are available
    const event = new CustomEvent('translationsLoaded', {
      bubbles: true,
      cancelable: true,
      detail: {
        previous: previousTranslator,
        current: asyncTranslator,
        preloadedLanguages: ['nl', 'en', 'de', 'du', 'fr'],
      },
    });
    document.dispatchEvent(event);
  })
  .catch(error => {
    console.error('Failed to initialize async translator:', error);
  });

export default asyncTranslator;
